module.exports = __webpack_public_path__ + "sd.808944c3.svg";